import {
  Component,
  OnInit,
  Renderer2,
  Input,
  ChangeDetectionStrategy,
  EventEmitter,
  Output,
  OnChanges,
} from '@angular/core'
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms'
import { QuoteDataService } from '../../services/quote-data.service'
import {
  BillToAddress,
  DeliveryAddress,
  EndUserAddress,
} from '../../model/address-models'
import { QuoteCheckoutService } from '../../services/quote-checkout.service'

@Component({
  standalone: false,
  selector: 'vs-guest-checkout',
  templateUrl: './guest-checkout.component.html',
  styleUrls: ['./guest-checkout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuestCheckoutComponent implements OnInit, OnChanges {
  @Input() orderType: any
  @Output() getNotificationEmail = new EventEmitter<string>()
  @Output() getContactNumber = new EventEmitter<string>()
  @Input() restrictedCountryCheck
  @Input() sanctionCheck
  @Input() requiresExportLicense
  @Input() isNuclear
  @Input() hasRestrictedUse
  @Input() customerReviewCheck
  @Input() isSubmitted = false
  @Input() count = 1
  @Input() validationGroup = 'bill-to'
  @Input() cartData
  @Input() rfqTypes
  @Input() orderChanged
  @Output() updateFile = new EventEmitter<any>()
  @Output() cartUpdate = new EventEmitter<any>()
  billToAddress: BillToAddress
  deliveryAddress: DeliveryAddress
  endUserAddress: EndUserAddress
  notificationsForm: FormGroup
  userIndustries = []
  legalEntity: any
  endCountry
  endUserIndustry: any
  complienceQuestions: {
    restrictedCountryCheck: any
    sanctionCheck: any
    requiresExportLicense: any
    isNuclear: any
    hasRestrictedUse: any
    customerReviewCheck: any
    restrictedPartList: any
    warningFlags: any
    governmentParties: any
  }
  legalEntityData: any
  showComplienceQues = false
  billToValidation: boolean
  complienceValidation: boolean
  endUserValidation: boolean
  deliveryValidation: boolean
  loggedIn = false
  @Input() restrictedPartList: any
  @Input() warningFlags: any
  @Input() governmentParties: any
  warningFlagText: any
  constructor(
    private fb: FormBuilder,
    private renderer: Renderer2,
    private quoteDataService: QuoteDataService,
    private quoteCheckoutService: QuoteCheckoutService
  ) {
    this.notificationsForm = this.fb.group({
      quoteAcknowldge: new FormControl(null, [
        Validators.required,
        Validators.pattern(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ),
      ]),
      contactNumber: [
        null,
        [
          Validators.required,
          Validators.pattern(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/),
          Validators.minLength(6),
          Validators.maxLength(16),
        ],
      ],
    })
  }
  ngOnChanges(changes) {}
  ngOnInit(): void {
    if (this.cartData.attachments) {
      this.quoteDataService.sendAttachments(this.cartData?.attachments)
    }

    this.quoteCheckoutService.checkSubmission.subscribe((data) => {
      if (
        data === true &&
        this.complienceValidation &&
        this.deliveryValidation &&
        this.billToValidation &&
        this.endUserValidation
      ) {
        this.scrollToError()
      }
    })
    this.quoteDataService.recieveBillToAddressValidation.subscribe(
      (valid: boolean) => {
        this.billToValidation = valid
      }
    )
    this.quoteDataService.recieveComplienceValidation.subscribe(
      (valid: boolean) => {
        this.complienceValidation = valid
      }
    )
    this.quoteDataService.recieveEndUserAddressValidation.subscribe(
      (valid: boolean) => {
        this.endUserValidation = valid
      }
    )
    this.quoteDataService.recieveDeliveryAddressValidation.subscribe(
      (valid: boolean) => {
        this.deliveryValidation = valid
      }
    )
    this.notificationsForm.valueChanges.subscribe((data) => {
      if (data.quoteAcknowldge) {
        this.cartData.notificationEmail = data.quoteAcknowldge
      }
      if (data.contactNumber) {
        this.cartData.contactNumber = data.contactNumber
      }
      this.quoteDataService.sendNotificationValidation(
        this.notificationsForm.valid
      )
    })
    this.notificationsForm.controls['quoteAcknowldge'].setValue(
      this.cartData?.notificationEmail
    )
    this.notificationsForm.controls['contactNumber'].setValue(
      this.cartData?.contactNumber
    )
    this.getLegalEntity()
    this.customerReviewCheck = this.cartData?.customerReviewCheck
    this.hasRestrictedUse = this.cartData?.hasRestrictedUse
    this.isNuclear = this.cartData?.isNuclear
    this.requiresExportLicense = this.cartData?.requiresExportLicense
    this.restrictedCountryCheck = this.cartData?.restrictedCountryCheck
    this.sanctionCheck = this.cartData?.sanctionCheck
    this.restrictedPartList = this.cartData?.restrictedPartList
    this.warningFlags = this.cartData?.warningFlags
    this.governmentParties = this.cartData?.governmentParties
    this.billToAddress = this.cartData?.billToAddress
    this.endUserAddress = this.cartData?.endUserAddress
    this.deliveryAddress = this.cartData?.deliveryAddress
    this.endUserIndustry = this.cartData?.endUserIndustry
    this.legalEntity = this.cartData?.legalEntity
    this.warningFlagText = this.cartData?.warningFlagText
    this.complienceQuestions = {
      restrictedCountryCheck: this.cartData?.restrictedCountryCheck,
      sanctionCheck: this.cartData?.sanctionCheck,
      requiresExportLicense: this.cartData?.requiresExportLicense,
      isNuclear: this.cartData?.isNuclear,
      hasRestrictedUse: this.cartData?.hasRestrictedUse,
      customerReviewCheck: this.cartData?.customerReviewCheck,
      restrictedPartList: this.cartData?.restrictedPartList,
      warningFlags: this.cartData?.warningFlags,
      governmentParties: this.cartData?.governmentParties,
    }
  }
  scrollToError(): void {
    const firstElementWithError = document.querySelector(
      '.ng-invalid[formControlName]'
    )
    this.scrollTo(firstElementWithError)
  }
  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      el.parentElement.focus()
    }
  }
  get quoteAcknowldge() {
    return this.notificationsForm.get('quoteAcknowldge')
  }
  get contactNumber() {
    return this.notificationsForm.get('contactNumber')
  }
  endCountryData(event) {
    this.endCountry = event
  }
  legalEntityChange(event) {
    this.legalEntity = event
    this.updateCart()
  }
  changeQuoteAcknowledgement() {
    this.getNotificationEmail.emit(
      this.notificationsForm.controls['quoteAcknowldge'].value
    )
  }
  changeContactNumber() {
    this.getContactNumber.emit(
      this.notificationsForm.controls['contactNumber'].value
    )
  }
  billToAddressUpdate(event) {
    this.billToAddress = event
    this.updateCart()
  }
  deliveryAddressUpdate(event) {
    this.deliveryAddress = event
    this.updateCart()
  }
  getSoldToAddress(event) {
    if (event) {
      this.cartData.deliveryAddress = this.cartData.billToAddress
    } else {
      this.cartData.deliveryAddress = null
    }
  }
  endCustomerAddressUpdate(event) {
    this.endUserAddress = event
    this.updateCart()
  }
  endUserIndustryUpdate(event) {
    this.endUserIndustry = event
    this.updateCart()
  }
  complienceQuestionsUpdates(event) {
    this.customerReviewCheck = event.customerReviewCheck
    this.hasRestrictedUse = event.hasRestrictedUse
    this.isNuclear = event.isNuclear
    this.requiresExportLicense = event.requiresExportLicense
    this.restrictedCountryCheck = event.restrictedCountryCheck
    this.sanctionCheck = event.sanctionCheck
    this.restrictedPartList = event.restrictedPartList
    this.warningFlags = event.warningFlags
    this.governmentParties = event.governmentParties
    this.updateCart()
  }
  updateCart() {
    this.cartData = {
      customerReviewCheck: this.customerReviewCheck,
      hasRestrictedUse: this.hasRestrictedUse,
      isNuclear: this.isNuclear,
      requiresExportLicense: this.requiresExportLicense,
      restrictedCountryCheck: this.restrictedCountryCheck,
      sanctionCheck: this.sanctionCheck,
      restrictedPartList: this.restrictedPartList,
      warningFlags: this.warningFlags,
      governmentParties: this.governmentParties,
      billToAddress: this.billToAddress,
      endUserAddress: this.endUserAddress,
      deliveryAddress: this.deliveryAddress,
      endUserIndustry: this.endUserIndustry,
      legalEntity: this.legalEntity,
      warningFlagText: this.warningFlagText,
      notificationEmail: this.notificationsForm.value.quoteAcknowldge,
      contactNumber: this.notificationsForm.value.contactNumber,
    }
    this.showComplienceQuestions()
    this.cartUpdate.emit(this.cartData)
  }
  warningFlagTextUpdate(event) {
    this.warningFlagText = event
    this.cartData.warningFlagText = event
    this.updateCart()
  }
  updateFiles(event) {
    this.updateFile.emit(event)
  }
  showComplienceQuestions() {
    var showCount = 0
    this.legalEntityData?.forEach((element) => {
      if (
        element.code == this.cartData?.legalEntity &&
        element.salesAreaAddress?.country?.isocode ==
          this.cartData?.endUserAddress?.country?.isocode &&
        this.cartData?.endUserAddress?.country.isocode != null &&
        this.cartData?.endUserAddress?.country.isocode != ''
      ) {
        showCount = showCount + 1
      } else {
      }
    })
    if (showCount > 0) {
      this.showComplienceQues = false
    } else {
      this.showComplienceQues = true
    }

    if (
      this.cartData.endUserAddress === undefined ||
      this.cartData.endUserAddress?.country === undefined
    ) {
      this.showComplienceQues = false
    }
  }
  getLegalEntity() {
    const legalEntity = 'legalEntity'
    this.quoteCheckoutService
      .getLegalEntity('anonymous')
      .subscribe((data: any) => {
        this.legalEntityData = data[legalEntity]
      })
  }
  acceptNumberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode
    if (
      charCode > 31 &&
      (charCode < 48 || charCode > 57) &&
      charCode !== 43 &&
      charCode !== 45 &&
      charCode !== 40 &&
      charCode !== 41 &&
      charCode !== 46 &&
      charCode !== 62
    ) {
      return false
    }
    return true
  }
}
